export default "__VITE_ASSET__66a45412__"